import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Title = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.B2C).UserContacts;

  return (
    <Stack gap={isDesktop ? '8px' : '4px'} mb={isDesktop ? '24px' : '32px'}>
      <Typography variant={isDesktop ? 'h3' : 'h2'}>
        {dictionary.title}
      </Typography>
      <Typography variant='body3'>{dictionary.subTitle}</Typography>
    </Stack>
  );
};
